import React, { ChangeEvent, PureComponent } from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';

interface ImageUploadProps extends WithTranslation {
  image?: string;
  isEdit: boolean;
  onImageSelect: (image: File) => void;
}

interface ImageUploadState {
  imageDataUrl: any;
}

class ImageUpload extends PureComponent<ImageUploadProps, ImageUploadState> {

  readonly state = {
    imageDataUrl: undefined
  };

  filesSelected = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget && e.currentTarget.files) {
      const file: File = e.currentTarget.files[0];

      this.props.onImageSelect(file);
      this.setState({ imageDataUrl: this.getDataUrl(file) });
    }
  };

  getDataUrl = (file: File) => URL.createObjectURL(file);

  render() {
    const { t } = this.props;

    return (
      <div>
        <div className="form-group row">
          <div className="col-6 d-flex align-items-center justify-content-end">
            <label>{t('l.car_model.image')}:</label>
          </div>
          <div className="col-6 d-flex align-items-center justify-content-start">
            { this.props.isEdit && (
            <input
              className="btn btn-primary btn-sm"
              type="file"
              placeholder={t('b.generic.choose_file')}
              accept="image/png, image/jpeg, image/jpg, image/webp"
              onChange={(e) => this.filesSelected(e)}
            />
            )}
          </div>
        </div>
        <div>
          { (this.props.image || this.state.imageDataUrl) && (
            <div className="car-image">
              <img src={this.state.imageDataUrl ? this.state.imageDataUrl : this.props.image} alt="Upload"></img>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(ImageUpload);
